module.exports = __webpack_public_path__ + "static/media/patrol(20).55b7d38e.PNG";